export type ContractHonorariumStatus = 'CURRENT' | 'FUTURE' | 'EXPIRED'

export interface ContractHonorariumListItemDTO {
  contracthonorariumid: number
  professional: string
  billingentityname: string
  healthentityname: string
  healthentityplanname: string
  nomenclator: string
  buildingname: string
  distributioncontracttype: number | null
  distributiontypename: string
  honopercentage: number | null
  copaymentpercentage: number | null
  diferentialpercentage: number | null
  fixedamount: number | null
  datestart: string
  dateend: string | null
  status: ContractHonorariumStatus
  /** El emisor es un profesional: el contrato es de retención y no de distribución. */
  billingEntityProfessional: boolean
}

export interface ContractHonorariumDetailDTO {
  id: number
  billingEntityName: string | null
  healthEntityName: string | null
  healthEntityPlanName: string | null
  professionalName: string | null
  nomenclatorName: string | null
  buildingName: string | null
  distributionTypeId: number | null
  honoPercentage: number | null
  copaymentPercentage: number | null
  diferentialPercentage: number | null
  fixedAmount: number | null
  validFrom: string
  validUntil: string | null
  status: ContractHonorariumStatus
  /** El emisor es un profesional: el contrato es de retención y no de distribución. */
  billingEntityProfessional: boolean
}

export interface ContractHonorariumValuesDTO {
  distributionTypeId: number | null
  honoPercentage: number | null
  copaymentPercentage: number | null
  diferentialPercentage: number | null
  fixedAmount: number | null
  /** yyyy-MM-dd (fecha local). */
  validFrom: string
  validUntil: string | null
}

export interface ContractHonorariumCreateDTO extends ContractHonorariumValuesDTO {
  billingEntityIds: number[]
  healthEntityIds: number[]
  healthEntityPlanIds: number[]
  professionalIds: number[]
  nomenclatorIds: number[]
  buildingIds: number[]
}

export type ContractHonorariumUpdateDTO = ContractHonorariumValuesDTO

export interface ContractHonorariumCombinationDTO {
  billingEntityName: string | null
  healthEntityName: string | null
  healthEntityPlanName: string | null
  professionalName: string | null
  nomenclatorName: string | null
  buildingName: string | null
}

export interface ContractHonorariumCreateResultDTO {
  created: number
  total: number
  duplicates: ContractHonorariumCombinationDTO[]
}

export interface ContractHonorariumHistoryItemDTO {
  id: number
  validFrom: string
  validUntil: string | null
  billingEntityName: string | null
  distributionTypeId: number | null
  distributionTypeName: string
  honoPercentage: number | null
  copaymentPercentage: number | null
  diferentialPercentage: number | null
  fixedAmount: number | null
  changeDate: string | null
  userName: string
}

export interface ContractHonorariumOptionDTO {
  id: number
  name: string
  /** Solo en los emisores: es un profesional (el contrato con él es de retención). */
  professional?: boolean
}

export interface ContractHonorariumPlanOptionDTO extends ContractHonorariumOptionDTO {
  healthEntityId: number
  healthEntityName: string
}

export interface ContractHonorariumOptionsDTO {
  billingEntities: ContractHonorariumOptionDTO[]
  healthEntities: ContractHonorariumOptionDTO[]
  professionals: ContractHonorariumOptionDTO[]
  distributionTypes: ContractHonorariumOptionDTO[]
  buildings: ContractHonorariumOptionDTO[]
}

export type ContractHonorariumFormField =
  | 'billingEntityIds'
  | 'healthEntityIds'
  | 'healthEntityPlanIds'
  | 'professionalIds'
  | 'nomenclatorIds'
  | 'buildingIds'
  | 'distributionTypeId'
  | 'honoPercentage'
  | 'copaymentPercentage'
  | 'diferentialPercentage'
  | 'fixedAmount'
  | 'validFrom'
  | 'validUntil'
  | 'combinations'

export type ContractHonorariumFormErrors = Partial<Record<ContractHonorariumFormField, string>>

export interface ContractHonorariumListQueryParams {
  multiSortMeta?: unknown
  filterDTO?: unknown
}

export const CONTRACT_HONORARIUM_STATUS_CODES: Record<ContractHonorariumStatus, number> = {
  CURRENT: 1,
  FUTURE: 2,
  EXPIRED: 3,
}

export interface ContractHonorariumBulkEditDTO {
  ids: number[]
  distributionTypeId: number | null
  honoPercentage: number | null
  copaymentPercentage: number | null
  diferentialPercentage: number | null
  fixedAmount: number | null
  fromDate: string | null
}

export interface ContractHonorariumBulkCloseDTO {
  ids: number[]
  closeDate: string
}

export type ContractHonorariumSkipReason = 'EXPIRED' | 'ENDS_BEFORE_DATE' | 'FUTURE' | 'NO_CHANGES'

export interface ContractHonorariumBulkResultDTO {
  modified: number
  skipped: number
  skippedByReason: Partial<Record<ContractHonorariumSkipReason, number>>
}
